export enum AreaType {
  'None' = 0,
  'CinemaRoom' = 1,
}
